import { connected } from '@ambiki/impulse';
import { findTopLayerElement } from 'helpers/dom-helper';

// Whether Bootstrap's tooltip plugin is loaded. This used to query every [data-toggle="tooltip"] on the page for each
// element connecting or leaving, so a page with T tooltips did T document-wide queries twice over.
const tooltipLoaded = () => typeof $.fn.tooltip === 'function';

/**
 * Initializes the bootstrap tooltip component when element is connected to the DOM and disposes it when element is
 * removed from the DOM.
 */
connected('[data-toggle="tooltip"]', (element) => {
  // Added boundary window to prevent flickering when a tooltip
  // is within a responsive table (Kevin 10/2022)
  // https://stackoverflow.com/a/62076857
  if (tooltipLoaded()) {
    // If the tooltip is placed inside a `dialog` or `popover` element, it should be rendered within
    // that element instead of being appended to the `body` (the default behavior) to prevent z-index issues.
    const topLayerElement = findTopLayerElement(element);
    $(element).tooltip({ boundary: topLayerElement || 'window', container: topLayerElement || false });
  }

  return () => {
    if (tooltipLoaded()) {
      $(element).tooltip('dispose');
    }
  };
});
